import { render } from "./Home.vue?vue&type=template&id=dea12988&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=dea12988&scoped=true&lang=css"

import exportComponent from "/Users/reahmiyara/Code/226CliftonPlace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea12988"]])

export default __exports__